import React from 'react';

export const CircularProgress = React.memo(({ loading }) => {
  return loading ? <div className="loading-indicator" /> : null;
});

CircularProgress.displayName = 'CircularProgress';
